<template>
  <div class="app">
    <van-collapse v-model="activeName" accordion @change="change">
      <van-collapse-item v-for="(item, index) in list" :key="index" :title="item.title" :name="index">
        <div v-if="item.children">
          <van-cell v-for="(m, i) in item.children" :key="i" :title="m.title" is-link @click="clickItem(m)" />
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
export default {
  data() {
    return {
      activeName: '',
      list: [],
    }
  },
  created() {
    this.getData()
  },
  mounted() {},
  methods: {
    getData() {
      getAction('/sys/category/loadTreeRoot?async=false&pcode=S06').then((res) => {
        if (res.success) {
          let list = res.result
          this.list = list
        }
      })
    },
    clickItem(item) {
      this.$router.push({
        path: '/gzfw/bszn-list',
        query: { code: item.code },
      })
    },
    change(e) {
      if (!e) return
      let index = e
      let obj = this.list[index]
      if (!obj.children) {
        let code = obj.code
        this.$router.push({
          path: '/gzfw/bszn-list',
          query: { code },
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.app {
  width: 100%;
  height: 100vh;
  background: #f6f7f9;
}
/deep/ .van-collapse-item__content {
  padding: 0;
}
</style>
